import { ParameterDefinition } from '@automata/wfb-api/src/apis/wfbApiSchemas';

type DataType = 'string' | 'number' | 'boolean';

// proper handling should be created here for other input types, see ticket
// https://automata-tech.atlassian.net/browse/G2-1730
export const getManualValueType = (
  value: string | number | string[] | number[]
): DataType => {
  if (!value) {
    return 'string';
  }

  if (!isNaN(Number(value))) {
    return 'number';
  }

  if (
    typeof value === 'string' &&
    ['true', 'false'].includes(value.toLowerCase())
  ) {
    return 'boolean';
  }

  return 'string';
};

const getSourceDataTypeFromParameter = (
  parameterReference: ParameterDefinition | undefined,
  value: string
): DataType | null => {
  if (!parameterReference) return null;

  switch (parameterReference.type) {
    case 'string':
      return 'string';
    case 'integer':
    case 'float':
      return 'number';
    case 'boolean':
      return 'boolean';
    default:
      return getManualValueType(value);
  }
};

const getSourceDataTypeFromType = (
  type: string | null,
  value: string
): DataType | null => {
  if (!type) return null;

  switch (type) {
    case 'str':
      return 'string';
    case 'int':
    case 'float':
    case 'bytes':
      return 'number';
    case 'bool':
      return 'boolean';
    default:
      return getManualValueType(value);
  }
};

export const getSourceDataType = (
  parameterReference: ParameterDefinition | undefined,
  type: string | null,
  value: string
): DataType => {
  return (
    getSourceDataTypeFromParameter(parameterReference, value) ??
    getSourceDataTypeFromType(type, value) ??
    getManualValueType(value)
  );
};

export const convertValueToType = (
  value: string,
  targetType: DataType
): string | number | boolean => {
  switch (targetType) {
    case 'number': {
      if (value.endsWith('.') || value === '' || value === '-') {
        return value;
      }
      const numValue = Number(value);
      return Number.isNaN(numValue) ? value : numValue;
    }
    case 'boolean':
      if (value.toLowerCase() === 'true') return true;
      if (value.toLowerCase() === 'false') return false;
      return value;
    case 'string':
    default:
      return value;
  }
};
